import { ITEMS_ALIGNMENT, MAX_CENTERED_ITEMS } from './items-display-page.constants';

export const getAlignmentClass = (itemsCount: number): string => {
    return itemsCount <= MAX_CENTERED_ITEMS ? ITEMS_ALIGNMENT.CENTER : ITEMS_ALIGNMENT.LEFT;
};
